<tax-modal-header>kkms.kkm.settings.cancel-disconnection-ofd-modal-title</tax-modal-header>
<tax-modal-content>
  <div class="text-box">
    <p translate>kkms.kkm.settings.cancel-disconnection-ofd-modal-text</p>
  </div>
  <div class="alert-box">
    <svg-icon key="info"></svg-icon>
    <div>
      <p translate>kkms.kkm.settings.cancel-disconnection-ofd-modal-alert1</p>
      <p translate>kkms.kkm.settings.cancel-disconnection-ofd-modal-alert2</p>
      <p translate>kkms.kkm.settings.cancel-disconnection-ofd-modal-alert3</p>
    </div>
  </div>
</tax-modal-content>
<tax-modal-footer>
  <div class="btn-box">
    <button class="button_blue" (click)="confirm()" translate>email.confirm.button</button>
  </div>
</tax-modal-footer>

